/**
 * Registers the VoxSmyth service worker for the PWA experience.
 *
 * - Skips registration entirely in development (CRA's hot reload + a service
 *   worker = pain).
 * - Listens for updates and prompts the next-paint to reload so users get
 *   fresh bundles without a hard refresh.
 */

export const registerServiceWorker = () => {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  if (process.env.NODE_ENV === 'development') return;

  // Wait for the page load event so SW registration doesn't compete with
  // first-paint network requests.
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        if (typeof console !== 'undefined') {
          console.info('[PWA] Service worker registered. scope:', reg.scope);
        }
        // When a new SW takes control, refresh the page once so the user
        // immediately runs the new bundle. Guard with a flag so we don't
        // reload-loop during installs.
        let reloaded = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (reloaded) return;
          reloaded = true;
          window.location.reload();
        });
      })
      .catch((err) => {
        console.warn('[PWA] Service worker registration failed:', err);
      });
  });
};
